import { useEffect, useState } from 'react';
import { useGame } from '../../contexts/GameContext';
import { talentLoanStore, type TalentRequest } from './TalentLoanStore';

/** Views subscribe to retained room/owner loans; closing a view cannot cancel a server action. */
export function useTalentRequest(_className: string | null) {
  const { player } = useGame();
  const owner = player?._id || player?.id || null;
  const [snapshot, setSnapshot] = useState(talentLoanStore.getSnapshot);
  useEffect(() => {
    talentLoanStore.sync(owner);
    setSnapshot(talentLoanStore.getSnapshot());
    const off = talentLoanStore.subscribe(() => setSnapshot(talentLoanStore.getSnapshot()));
    const timer = setInterval(() => talentLoanStore.sync(owner), 500);
    return () => { clearInterval(timer); off(); };
  }, [owner]);
  return { ...snapshot, begin: (request: TalentRequest, dispatch: () => void) => talentLoanStore.begin(owner, request, dispatch) };
}
